import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

export default function Dashboard() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      {/* <Button aria-describedby={id} variant="contained" onClick={handleClick}>
        Open Popover
      </Button> */}
      <IconButton size="medium" disableRipple onClick={handleClick}>
        <Icon>account_circle</Icon>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <MDBox sx={{ bgcolor: "background.paper" }}>
          {/* <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
          <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
          <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
          <Typography sx={{ p: 2 }}>The content of the Popover.</Typography> */}
          <MDButton>LogOut</MDButton>
        </MDBox>
      </Popover>
    </>
  );
}
